import { CalendarPlottedEvent } from '../../services/enterpriseCalendarsApi';
import { plottedEventOccursOnDay } from './calendarRecurrenceUtils';
import { getMonthGrid, getYearMonths, isSameDay } from './calendarUtils';

type CalendarYearViewProps = {
  year: number;
  events: CalendarPlottedEvent[];
  onDayClick?: (day: Date) => void;
};

const MONTH_LABELS = [
  'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
  'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez',
];

export function CalendarYearView({ year, events, onDayClick }: CalendarYearViewProps) {
  const today = new Date();
  const months = getYearMonths(year);

  return (
    <div className="h-full min-h-0 overflow-y-auto rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
        {months.map((month, monthIndex) => {
          return (
            <div key={month.toISOString()} className="rounded-xl border border-slate-100 p-3">
              <p className="mb-2 text-sm font-semibold text-slate-800">{MONTH_LABELS[monthIndex]}</p>
              <div className="grid grid-cols-7 gap-1 text-center text-[10px] text-slate-400">
                {['D', 'S', 'T', 'Q', 'Q', 'S', 'S'].map((label) => (
                  <span key={`${monthIndex}-${label}`}>{label}</span>
                ))}
              </div>
              <div className="mt-1 grid grid-cols-7 gap-1">
                {getMonthGrid(month).map((day) => {
                  const inMonth = day.getMonth() === month.getMonth();
                  const dayEvents = events.filter((event) => plottedEventOccursOnDay(event, day));
                  const isToday = isSameDay(day, today);

                  return (
                    <button
                      key={day.toISOString()}
                      type="button"
                      className={`relative flex h-7 w-7 items-center justify-center rounded-full text-[11px] ${
                        !inMonth
                          ? 'text-slate-300'
                          : isToday
                            ? 'bg-primary-600 font-semibold text-white'
                            : 'text-slate-700 hover:bg-slate-100'
                      }`}
                      onClick={() => inMonth && onDayClick?.(day)}
                      title={dayEvents.map((event) => event.name).join(', ')}
                      disabled={!inMonth}
                    >
                      {day.getDate()}
                      {inMonth && dayEvents.length > 0 && !isToday ? (
                        <span className="absolute bottom-0.5 h-1 w-1 rounded-full bg-primary-500" />
                      ) : null}
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
